'use strict';

import _ from 'lodash';

export function findContact(criteria, contacts) {
  return _.filter(contacts, criteria)[0];
}

export function contactInGroups(criteria, contacts) {
  return _.reduce(contacts, (list, group, name) => {
    const index = _.findIndex(group, criteria);
    if (~index) {
      list.push({name, index});
    }
    return list;
  }, []);
}

export function findGrouping({contact, groups}) {
  const group = _.reduce(groups, (list, group) => {
    if (group.statuses.find((status) => status === contact.profile.contactStatus)) {
      list.push(group.name);
    }
    return list;
  }, [])[0];
  return {contact, group};
}



// WEBPACK FOOTER //
// ./shared/redux/helpers/contacts.js